module.exports = __webpack_public_path__ + "img/frame (2).c902b4bf.jpg";